
        import * as module0 from './controllers/alert_banner_controller.js';import * as module1 from './controllers/menu_active_controller.js';import * as module2 from './controllers/mobile_menu_controller.js'
        const modules = {
            "./controllers/alert_banner_controller.js": module0,
            "./controllers/menu_active_controller.js": module1,
            "./controllers/mobile_menu_controller.js": module2,
        };
        export default modules;
      